import { UserProfileTypes } from 'services/requests';
import { EmployeeProfileTypes } from './IndependentIraTable/IndependentIraTable.const';

export const mapIndependentIraTypeValueToKey = (type?: string) =>
  Object.entries(UserProfileTypes).find((item) => item[1] === type)?.[0] ?? '';

export const mapIndependentIraTypeKeyToValue = (type?: string) =>
  Object.entries(UserProfileTypes).find((item) => item[0] === type)?.[1] ?? '';

export const isIraUser = (userProfileType: string): boolean =>
  userProfileType in EmployeeProfileTypes;
